import axios from "axios";
import store from "../store";

export namespace FormApi {
    export const submitForm = async () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';

        return axios({
            method: 'POST',
            url: `${apiBaseUrl}/api/submitForm`,
            data: {
                tourLeader: store.tourLeader,
                paxList: store.paxList,
                bookingPreference: store.groupPreferences,
                accList: store.preferredAccommodationList,
                otherComments: store.generalComments,
            },
        });
    }
}
